import React, { useEffect, useState } from 'react';
// import AdminHeader from './AdminHeader.js';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
// import { GET_ORDERS } from '../graphql/Query/Order.js';
import moment from 'moment';
// import Loader from '../components/Loader.js';
// import CustomPagination from '../components/Pagination.js';
// import useScrollToTop from '../components/useScrollToTop.js';
import AdminHeader from '../AdminHeader.js';
import CustomPagination from '../../components/Pagination.js';
import Loader from '../../components/Loader.js';
import { GET_ORDER_SAME_DAY } from '../../graphql/Mutation/SameDayOrder.js';


const BikeTodayOrder = () => {
    //   useScrollToTop();
    const [activeButton, setActiveButton] = useState('');
    const [paymentCf, setPaymentCf] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [filter, setFilter] = useState('');
    const [todayTicketCount, setTodayTicketCount] = useState(0);
    const [cancelCourier, setCancelCourier] = useState();
    const [cancelOrder, setCancelOrder] = useState(0);
    const [paymentStatus, setpaymentStatus] = useState();

    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(200);

    const { data, loading } = useQuery(GET_ORDER_SAME_DAY, {
        variables: {
            "page": page + 1,
            "limit": limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter,
            "from": fromDate,
            "to": toDate,
            "orderStatus": cancelCourier,
            "paymentStatus": paymentStatus

        },
        fetchPolicy: 'cache-and-network'
    });
    // console.log('✌️data --->', data);

    useEffect(() => {
        if (data?.getOrdersforSameDay?.data) {
            const today = moment().startOf('day');
            const todaySameDayOrder = data?.getOrdersforSameDay?.data?.filter((order) => moment(order?.createdAt).isSame(today, 'day'));

            const canceledOrder = data?.getOrdersforSameDay?.data?.filter((order) =>
                order.status === 'cancelled' && moment(order?.createdAt).isSame(today, 'day')
            );
            setCancelOrder(canceledOrder?.length);
            setTodayTicketCount(todaySameDayOrder?.length);
        }
    }, [data]);

    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
    }

    const searchCustomerUser = () => {
        setFilter(searchUser);
        setPage(0);
    }

    const handleSearch = (e) => {
        searchCustomerUser()
    }

    const handleReset = () => {
        setFromDate('');
        setToDate('');
        setFilter('');
        setSearchUser('');
        setCancelCourier('');
        setpaymentStatus('');
        setPaymentCf('');
        setActiveButton("")
        setPage(0);
    }

    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
    };
    return (
        <div>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-2 sm:px-6 lg:px-8 my-10 ">
                <div className='flex flex-wrap justify-between'>
                    <div>
                        <h2 className="text-lg font-semibold text-green-500">All Shipment</h2>
                    </div>

                    <div className='flex mt-3 md:mt-0 flex-wrap'>
                        <h2 className="text-lg font-semibold me-5 text-green-500">Today Order - {todayTicketCount}</h2>
                        <h2 className="text-lg font-semibold text-red-500 mt-2 md:mt-0">Today Canceled Order - {cancelOrder}</h2>
                    </div>
                </div>
                <div className='p-4 max-w-full mx-auto bg-slate-50 ring-1 ring-gray-200 rounded-xl space-y-4'>
                    <div className=''>
                        <div>
                            <h2 className="text-lg font-bold mb-3 md:mb-0">Shipment Filters</h2>
                        </div>
                        <div className='mt-7'>
                            {/* <button
                                className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                onClick={handleReset}
                            >
                                Reset
                            </button> */}
                            <button
                                className={`px-4 py-1 border rounded-md ${activeButton === 'reset' ? 'bg-slate-900 text-white' : 'bg-white text-slate-900 hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('reset');
                                    handleReset();
                                }}
                            >
                                Reset
                            </button>
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'cancelled' ? 'bg-slate-900 text-white' : 'hover:bg-slate-900 hover:text-white bg-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('cancelled'); // Set active button to 'cancelled'
                                    setCancelCourier('cancelled'); // Perform the cancel action
                                }}
                            >
                                Cancel Bike
                            </button>
                            {/* <button
                                className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                onClick={() => { setCancelCourier('open'); }}
                            >
                                open
                            </button> */}

                            <button
                                className={`px-4 py-1 border rounded-md ${activeButton === 'open' ? 'bg-slate-900 text-white' : 'hover:bg-slate-900 hover:text-white bg-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('open'); // Set active button to 'cancelled'
                                    setCancelCourier('open'); // Perform the cancel action
                                }}
                            >
                                Open
                            </button>
                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                onClick={() => { setCancelCourier('accepted'); }}
                            >
                                accepted
                            </button> */}

                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${activeButton === 'accepted' ? 'bg-slate-900 text-white' : 'hover:bg-slate-900 hover:text-white bg-white'
                                    }`}
                                onClick={() => {
                                    setActiveButton('accepted'); // Set active button to 'cancelled'
                                    setCancelCourier('accepted'); // Perform the cancel action
                                }}
                            >
                                Accepted
                            </button>

                            {/* <br></br> */}

                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                onClick={() => { setpaymentStatus('ACTIVE'); }}
                            >
                                ACTIVE CF
                            </button> */}

                            <button
                                className={`px-4 py-1 border rounded-md ${paymentCf === 'ACTIVE' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('ACTIVE');
                                    setpaymentStatus('ACTIVE');
                                }}
                            >
                                CF Active
                            </button>
                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                onClick={() => { setpaymentStatus('Success'); }}
                            >
                                Success CF
                            </button> */}
                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${paymentCf === 'SUCCESS' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('SUCCESS');
                                    setpaymentStatus('SUCCESS');
                                }}
                            >
                                CF Success
                            </button>
                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                onClick={() => { setpaymentStatus('Pending'); }}
                            >
                                Pending CF
                            </button> */}

                            <button
                                className={`px-4 py-1 border rounded-md ${paymentCf === 'NOT_ATTEMPTED' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('NOT_ATTEMPTED');
                                    setpaymentStatus('NOT_ATTEMPTED');
                                }}
                            >
                                CF Not_Attempted
                            </button>
                            {/* <button
                                className="px-4 py-1 md:ms-3 mt-3 md:mt-0 ms-3 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                                onClick={() => { setpaymentStatus('Failure'); }}
                            >
                                Failure CF
                            </button> */}

                            <button
                                className={`px-4 py-1 mx-3 border rounded-md ${paymentCf === 'FAILED' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('FAILED');
                                    setpaymentStatus('FAILED');
                                }}
                            >
                                CF Failed
                            </button>

                            <button
                                className={`px-4 py-1 border rounded-md ${paymentCf === 'USER_DROPPED' ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-900 hover:text-white'
                                    }`}
                                onClick={() => {
                                    setPaymentCf('USER_DROPPED');
                                    setpaymentStatus('USER_DROPPED');
                                }}
                            >
                                CF User_Dropped
                            </button>


                        </div>

                    </div>

                    <div className='lg:flex space-y-7 lg:space-y-0 lg:justify-between'>
                        <div>
                            <p className="text-sm font-medium text-gray-700">Search</p>
                            <div className='md:flex md:space-x-4 space-x-0'>
                                <div>
                                    <input type="text" onChange={(e) => setSearchUser(e.target.value)} onKeyDown={handleSearch} value={searchUser} placeholder="Search..." className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none p-1.5 border rounded-md" />                                </div>
                            </div>
                        </div>

                        <div className='md:flex md:space-x-4 space-x-0 space-y-3 md:space-y-0'>
                            <div>
                                <p className="text-sm font-medium text-gray-700">From</p>
                                <div className='md:flex md:space-x-4 space-x-0'>
                                    <input
                                        type="date"
                                        className="mt-1 w-full md:w-none p-1.5 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 border rounded-md"
                                        value={fromDate}
                                        onChange={(e) => { fromDateChange(e) }}
                                    />
                                </div>
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-700">To</p>
                                <div className='md:flex md:space-x-4 space-x-0'>
                                    <div>
                                        <input
                                            type="date"
                                            className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none p-1.5 border rounded-md"
                                            value={toDate}
                                            onChange={(e) => toDateChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=''>
                    <div className='justify-end flex  '>
                        {/* <div className='mt-2' >
                            <label >
                                Items per page:
                                <select value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
                                 
                                    <option value={100}>100</option>
                                    <option value={50}>50</option>
                                </select>
                            </label>
                        </div> */}

                        <div>
                            {data?.getOrdersforSameDay?.count > 0 && (
                                <CustomPagination
                                    totalItems={data?.getOrdersforSameDay?.count || 0}
                                    limit={limit}
                                    pageNo={page}
                                    handlePageClick={handlePageClick}
                                />)}
                        </div>
                    </div>
                </div>

                <div className="overflow-x-auto rounded-t-xl  border border-gray-200">

                    <p className='font-semibold m-3'>Total : {data?.getOrdersforSameDay?.count} </p>
                    <table className="min-w-full bg-white">
                        <thead>
                            <tr>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">No.</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Order Date</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Order No.</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Customer Name</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Pickup Address</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Delivery Address</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Request Id</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Order Amount</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">status</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">CF status</td>
                                <td className="py-4 text-sm font-semibold bg-slate-50  px-4 border-b">Full Details</td>
                            </tr>
                        </thead>
                        {loading ?
                            <Loader className="mx-auto" />
                            : (
                                <tbody>
                                    {data?.getOrdersforSameDay?.count > 0 && data?.getOrdersforSameDay?.data && data?.getOrdersforSameDay?.data.map((row, index) => (
                                        <tr key={index} className='hover:bg-slate-50'>
                                            <td className="py-2.5 text-sm px-4 border-b">{index + 1 + (page * limit)}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{moment(row?.createdAt).format('DD/MM/YYYY hh:mm A')}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.order_id}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.data?.pickup_details?.address?.contact_details?.name}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.data?.pickup_details?.address?.street_address1}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.data?.drop_details?.address?.street_address1}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.request_id}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.order_amount}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.status}</td>
                                            <td className="py-2.5 text-sm px-4 border-b">{row?.paymentStatus}</td>
                                            <td className="py-2.5 text-sm px-4 border-b text-blue-400 font-semibold"><Link to='/adminSamedayOrderSingle' state={{ id: row?.id }}> View Details</Link></td>
                                        </tr>
                                    ))}
                                </tbody>
                            )}
                    </table>
                </div>


            </div>
        </div>
    )
}

export default BikeTodayOrder;